import React from 'react';
import { range, random, sample, last } from 'lodash';
import { Icon } from 'ui';

const TOTAL_DUST = 3;

const ICONS = ['dust1', 'dust2'];

const POSITIONS = [
  [
    [0, 2],
    [0, 0],
    [0, -1],
    [2, -1],
    [2, -2],
    [3, -1],
  ],
  [
    [7, -2],
    [8, -1],
    [10, -1],
    [12, 1],
  ],
  [
    [12, 8],
    [11, 10],
    [10, 11],
    [8, 12],
  ],
  [
    [4, 12],
    [3, 11],
    [2, 12],
    [2, 11],
    [0, 11],
    [0, 9],
  ],
];

let arr = [];
function getUniquePosition() {
  if (arr.length === TOTAL_DUST) arr = [];
  while (arr.length < POSITIONS.length) {
    const idx = random(0, POSITIONS.length - 1);
    if (!arr.includes(idx)) {
      arr.push(idx);
      break;
    }
  }
  return sample(POSITIONS[last(arr)]);
}

const getCSSPosition = () => {
  const [top, left] = getUniquePosition().map(n => `${n * 10}%`);
  return { top, left };
};

const getStyle = () => ({
  fontSize: `${random(8, 12)}px`,
  opacity: random(0.5, 1, true),
  transform: 'translate(-50%, -50%)',
  ...getCSSPosition(),
});

const renderDustPiece = i => (
  <Icon
    className="c-green pos-a"
    style={getStyle()}
    name={sample(ICONS)}
    key={`dust_${i}`}
    stabilize={false}
  />
);

function renderDust() {
  return range(TOTAL_DUST).map(renderDustPiece);
}

export default renderDust;
